export default "__VITE_ASSET__BdyW0srg__"